export class Usuario {
    idUsuario: number;
    claveUsuario: string;
    nombre: string;
    apellido: string;
    fechaNacimiento: Date;
    direccion: string;
    telefono: string;
    email: string;
    idTipoUsuario: number;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/usuario.ts